import React, { useState } from "react";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Send, Mail } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. We'll be in touch shortly.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (e) { toast.error("Send failed"); }
    finally { setSubmitting(false); }
  };

  return (
    <Layout>
      <section className="container-summit py-16 md:py-24 max-w-3xl">
        <div className="overline mb-6"><span className="accent-rule" />Contact</div>
        <h1 className="text-4xl sm:text-5xl">How can we help?</h1>
        <p className="mt-4 text-zinc-500">The Display America team is on standby for anything you need before, during, or after the Summit.</p>

        <div className="mt-10 border border-zinc-200 p-6 mb-10">
          <div className="overline">Support</div>
          <a href="mailto:info@displayamerica.com" data-testid="contact-info-email"
             className="mt-2 text-lg inline-flex items-center gap-2 hover:text-[#A39171]">
            <Mail size={16} /> info@displayamerica.com
          </a>
        </div>

        <form onSubmit={submit} className="card-flat p-6 md:p-8 grid gap-5">
          <div className="grid md:grid-cols-2 gap-5">
            <F label="Your Name"><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-12 rounded-none" data-testid="contact-name" /></F>
            <F label="Email"><Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-12 rounded-none" data-testid="contact-email" /></F>
          </div>
          <F label="Subject"><Input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="h-12 rounded-none" data-testid="contact-subject" /></F>
          <F label="Message"><Textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-none" data-testid="contact-message" /></F>
          <button type="submit" disabled={submitting} className="btn-black" data-testid="contact-submit">
            <Send size={16} /> {submitting ? "Sending…" : "Send Message"}
          </button>
        </form>
      </section>
    </Layout>
  );
}

function F({ label, children }) { return (<div><Label className="overline">{label}</Label><div className="mt-2">{children}</div></div>); }
